import Image from "next/image";

import { APP_STORE_LINK } from "@domains/common/constants/deepLinks";
import { isIOSAndMac } from "@logics/utils/isMobile";

import * as S from "./Download.style";

const Download = () => {
  const handleDownloadClick = () => {
    if (isIOSAndMac()) {
      window.open(APP_STORE_LINK.IOS, "_blank");
    } else {
      window.open(APP_STORE_LINK.ANDROID, "_blank");
    }
  };

  return (
    <S.Page>
      <S.Container>
        <S.Wrapper>
          <S.LogoContainer>
            <S.Logo>
              <Image fill src="/logo/enkoplay-logo.svg" alt="main-logo" />
            </S.Logo>
          </S.LogoContainer>

          <S.DownloadButton onClick={handleDownloadClick}>
            Download the app
          </S.DownloadButton>
        </S.Wrapper>
      </S.Container>
    </S.Page>
  );
};

export default Download;
